import { Component, OnInit, Input } from '@angular/core';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { ConfigFieldBuilderService } from '../config-field-builder.service';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { FormGroup } from '@angular/forms';
import { BookingSearchParameters } from 'libraries/interfaces/IBookingSearchParameters';
import {AFIDIUM_REMARK_ARRAY_FIELDS} from "../config";

@Component({
    selector: 'remark-fieldset',
    template: `
        <div class="sep-top">
            <collapsible [title]="labels.title" [open]="open">
                <div class="col-to-row-s-tb sep-top">
                    <div class="flex-1">
                        <chips [fieldConfig]="configurations.remarkText" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>
                <div class="col-to-row-s-tb">
                    <div class="flex-1 sep-top">
                        <chips [fieldConfig]="configurations.remarkInvoicing" [toUpper]="chipsToUpper"></chips>
                    </div>
                    <div class="flex-1 sep-top sep-left">
                        <chips [fieldConfig]="configurations.remarkNote" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>

                <div class="col-to-row-s-tb">
                    <div class="flex-1 sep-top">
                        <chips [fieldConfig]="configurations.remarkRemark" [toUpper]="chipsToUpper"></chips>
                    </div>
                    <div class="flex-1 sep-top sep-left">
                        <chips [fieldConfig]="configurations.remarkOsi" [toUpper]="chipsToUpper"></chips>
                    </div>
                </div>
                <div class="col-to-row-s-tb">
                    <div class="flex-1 sep-top">
                        <chips [fieldConfig]="configurations.remarkVendorAlert" [toUpper]="chipsToUpper"></chips>
                    </div>
                    <div class="flex-1 sep-top sep-left"></div>
                </div>
            </collapsible>
        </div>
    `,
    styles: [``]
})
export class RemarkFieldsetComponent implements OnInit {
    @Input()
    public open: boolean;

    @Input()
    public form: FormGroup;

    @Input()
    public chipsToUpper: boolean;

    public configurations: { [key: string]: IFieldSpecs };

    public labels: ILabels = {
        title: Yii.t("wui-sasha-js", "Remarques")
    };

    constructor(
        private readonly configFieldBuilderService: ConfigFieldBuilderService,
    ) { }

    public ngOnInit(): void {
        this.configurations = this.configFieldBuilderService.buildFieldConfigArray(
            this.form,
            AFIDIUM_REMARK_ARRAY_FIELDS
        );
    }
}
